import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }

import { ref, defineAsyncComponent } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'indexCreative',
  setup(__props) {

const borderCard = defineAsyncComponent(() => import("@/components/theme/advance/creative/borderCard.vue"))
const primaryState = defineAsyncComponent(() => import("@/components/theme/advance/creative/primaryState.vue"))
const warningState = defineAsyncComponent(() => import("@/components/theme/advance/creative/warningState.vue"))
const secondaryState = defineAsyncComponent(() => import("@/components/theme/advance/creative/secondaryState.vue"))
const absoluteCard = defineAsyncComponent(() => import("@/components/theme/advance/creative/absoluteCard.vue"))

return (_ctx: any,_cache: any) => {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumbs, {
      main: "Bonus Ui",
      title: "Creative Card"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(borderCard)),
        _createVNode(_unref(primaryState)),
        _createVNode(_unref(warningState)),
        _createVNode(_unref(secondaryState)),
        _createVNode(_unref(absoluteCard))
      ])
    ])
  ], 64))
}
}

})